export enum TopUserFilter {
    Nominal = 'nominal',
    Product = 'product',
    Meeting = 'meeting',
    Progress = 'progress',
} 